/**
 * @flow
 * @relayHash b704e35ef3601922397f0b00cf3f4929
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type LogoutMutationVariables = {|
  lo: string
|};
export type LogoutMutationResponse = {|
  +logout: ?{|
    +ok: ?boolean,
    +reasons: ?any,
    +redirectPath: ?string,
  |}
|};
export type LogoutMutation = {|
  variables: LogoutMutationVariables,
  response: LogoutMutationResponse,
|};
*/


/*
mutation LogoutMutation(
  $lo: String!
) {
  logout(lo: $lo) {
    ok
    reasons
    redirectPath
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "lo",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "logout",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "lo",
        "variableName": "lo",
        "type": "String!"
      }
    ],
    "concreteType": "Logout",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "ok",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "reasons",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "redirectPath",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "LogoutMutation",
  "id": "efbf9b84ea4cd4e1bf2cbb37e163643a",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "LogoutMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "LogoutMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
node.text = "mutation LogoutMutation(\n  $lo: String!\n) {\n  logout(lo: $lo) {\n    ok\n    reasons\n    redirectPath\n  }\n}\n";
(node/*: any*/).hash = '15c3a9183133e1e0a70cbbb2571945ec';
module.exports = node;
